import { find } from 'lodash';

export const REPORT_INSTITUTION_SET_REPORT_DATA = 'REPORT_INSTITUTION_SET_REPORT_DATA';
export const REPORT_INSTITUTION_LOAD_DATA_SOURCE = 'REPORT_INSTITUTION_LOAD_DATA_SOURCE';
export const REPORT_INSTITUTION_SELECT_CHOICE_OPTION = 'REPORT_INSTITUTION_SELECT_CHOICE_OPTION';
export const REPORT_INSTITUTION_LOAD_SELECTED_REPORT = 'REPORT_INSTITUTION_LOAD_SELECTED_REPORT';
export const REPORT_INSTITUTION_UNLOAD = 'REPORT_INSTITUTION_UNLOAD';

export const REPORT_TABLE_ACTIONS = {
    SET_REPORT_DATA: 'SET_REPORT_DATA',
    RESET_REPORT_DATA: 'RESET_REPORT_DATA',
    LOADED_REPORT_DATA: 'LOADED_REPORT_DATA',
    LOADING_REPORT_DATA: 'LOADING_REPORT_DATA',
    LOADING_CUSTOMIZE_COLUMNS: 'LOADING_CUSTOMIZE_COLUMNS',
    LOADED_CUSTOMIZE_COLUMNS: 'LOADED_CUSTOMIZE_COLUMNS',
    SET_CUSTOMIZE_COLUMNS_DATA: 'SET_CUSTOMIZE_COLUMNS_DATA',
    RESET_CUSTOMIZE_COLUMNS: 'RESET_CUSTOMIZE_COLUMNS',
    SET_EMAIL_CONFIGS: 'SET_EMAIL_CONFIGS',
    RESET_EMAIL_CONFIGS: 'RESET_EMAIL_CONFIGS',
    LOADED_EMAIL_CONFIG: 'LOADED_EMAIL_CONFIG',
    LOADING_EMAIL_CONFIG: 'LOADING_EMAIL_CONFIG',
    LOADED_ADD_EMAIL_CONFIG: 'LOADED_ADD_EMAIL_CONFIG',
    LOADING_ADD_EMAIL_CONFIG: 'LOADING_ADD_EMAIL_CONFIG',
};

export const statusKey = 'statuses';

export const reportTypes = {
    binder: 'binder',
    task: 'task',
    document: 'document',
    expiringDocument: 'expiringDocument',
    unfiledDocument: 'unfiledDocument',
    userDocumentAuditTrail: 'userDocumentAuditTrail',
    billableHistory: 'billableHistory',
};

export const reportLinks = [
    {
        to: '/admin/report/binders',
        title: 'Binders',
        type: reportTypes.binder,
    },
    {
        to: '/admin/report/documents',
        title: 'Documents',
        type: reportTypes.document,
    },
    {
        to: '/admin/report/tasks',
        title: 'Document Tasks',
        type: reportTypes.task,
    },
    {
        to: '/admin/report/expiring-documents',
        title: 'Expiring Documents',
        type: reportTypes.expiringDocument,
    },
    {
        to: '/admin/report/unfiled-documents',
        title: 'Unfiled Documents',
        type: reportTypes.unfiledDocument,
    },
    {
        to: '/admin/report/user-document-audit-trail',
        title: 'User Document Audit Trail',
        type: reportTypes.userDocumentAuditTrail,
    },
    {
        to: '/admin/report/billable-history',
        title: 'Billable Status Audit History',
        type: reportTypes.billableHistory,
    },
];

export const getReporTitle = (reportType) => {
    return find(reportLinks, { type: reportType }).title;
};

export const reportPlaceholder = {
    binders: 'Select binders',
    [statusKey]: 'Select binder status',
    documentTypes: 'Select document types',
    emails: 'Select emails',
};

export const binderStatus = [
    { key: 'active', label: 'Active' },
    { key: 'archived', label: 'Archived' },
    { key: 'new', label: 'New' },
];

export const INBOX_DATE_FORMAT = 'DD MMM YYYY'; // format as specified in 
// https://complion.atlassian.net/wiki/spaces/ENG/pages/3023044612/Input+and+Display+of+Dates+and+Time+Zones
export const DATE_FORMAT = 'YYYY-MM-DD';

export const DATETIME_FORMAT = 'MMM DD, YYYY hh:mm A';

export const DATE_FORMAT_INPUT = 'mm/dd/yyyy';

export const TIME_FORMAT = 'hh:mm A';

export const DEFAULT_LIMIT = 25;

export const DEFAULT_OFFSET = 0;

export const DEFAULT_DEBOUNCE_INTERVAL = 300;